import script from "./CourseInfoView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CourseInfoView.vue?vue&type=script&lang=ts&setup=true"

import "./CourseInfoView.vue?vue&type=style&index=0&id=d927b240&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d927b240"]])

export default __exports__